export default __webpack_public_path__ + "static/media/indesit.314bc711.svg";